import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ui-fh-svg-agreement',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './fh-svg-agreement.component.html',
  styleUrl: './fh-svg-agreement.component.scss'
})
export class FhSvgAgreementComponent {
  @Input() color: string = '';
}
